export default {
  最新采购商机: '最新采购商机',
  恭喜: '恭喜',
  成为了: '成为了',
  发布的: '发布的',
  采购需求的供应商: '采购需求的供应商',

  发布我的采购需求: '发布我的采购需求',
  产品名称: '产品名称',
  产品名称不能为空: '产品名称不能为空',
  产品名称不能超过60个字符: '产品名称不能超过60个字符',
  请输入采购产品名称: '请输入采购产品名称',
  请输入的手机号: '请输入的手机号',
  请输入正确格式的手机号: '请输入正确格式的手机号',
  发布我的采购需求提示1: '*手机号若未注册,则系统会默认自动注册并登录',
  发布我的采购需求提示2: '推送给优质供应商,让供应商主动给您报价',
  其他补充要求: '其他补充要求',
  '上传附件/设置采购总金额': '上传附件/设置采购总金额',

  发布成功: '发布成功',

  采购地区: '采购地区',
  排序: '排序',
  时间排序: '时间排序',
  设置排序: '设置排序',
  加入标签: '加入标签',
  正序: '正序',
  倒序: '倒序',
  无标题: '无标题',
  采购类型: '采购类型',
  预估采购金额: '预估采购金额',
  收货地区: '收货地区',
  具体洽谈: '具体洽谈',
  全球: '全球',
  全国: '全国（中国）',
  长期有效: '长期有效',
  距离报价结束: '距离报价结束',
  还剩: '还剩',
  已采购: '已采购',
  立即报价: '立即报价',
  已有: '已有',
  人报价: '人报价',
  采购描述: '采购描述',
  附件: '附件',
  被Ta选中的供应商: '被Ta选中的供应商',
  更多云采购推荐: '更多云采购推荐',
  暂无推荐: '暂无推荐',
  采购详情提示1: '个人用户无法发起云采购合作,请先申请成为企业再重试！',
  采购详情提示2: '不能与自己洽谈!',
  个人用户暂时无法洽谈: '个人用户暂时无法洽谈',
  请登录: '请登录',

  会员中心云采购详情提示1: '下架之后不可恢复,确定要下架吗?',
  完成采购: '完成采购',
  采购编号: '采购编号',
  活动状态: '活动状态',
  永久: '永久',
  天后过期: '天后过期',
  类别: '类别',
  具体描述: '具体描述',
  热门供应商: '热门供应商',
  换一批: '换一批',
  暂无热门供应商: '暂无热门供应商',
  我的候选供应商: '我的候选供应商',
  预选为供应商: '预选为供应商',
  洽谈: '洽谈',
  周: '周',
  月: '月',
  采购中: '采购中',
  自主下架: '自主下架',
  平台下架: '平台下架',
  供应商: '供应商',
  剩余有效期: '剩余有效期',
  供: '供',
  采: '采',
  类型: '类型',
  系统推荐: '系统推荐',
  主动联系: '主动联系',
  是否候选为供应商: '是否候选为供应商',
  已选预为供应商: '已选预为供应商',
  采购完成: '采购完成',
  下架成功: '下架成功',
  请从以下您未选中的供应商作为最终的预备采购企业: '请从以下您未选中的供应商作为最终的预备采购企业',
  跳过不选择: '跳过,不选择',
  选中成功: '选中成功',
  正在提交数据请稍等: '正在提交数据请稍等',
  确认提示: '确认提示',
  采购组件确认提示1: '您本次采购未选择任何一个企业作为供应商,确定要完成此采购吗？',
  已选为供应商: '已选为供应商',
  选为供应商: '选为供应商',
  采购组件确认提示2: '该企业已被选为供应商,无需重复选择！',
  报价: '报价',
  求: '求',
  暂无描述: '暂无描述',
  剩余时间: '剩余时间',
  暂无类型: '暂无类型',
  采购提示1: '个人用户无法浏览云采购信息,请申请成为企业用户！',
  采购提示2: '查询云采购信息条数已用光,若想查看更多云采购信息,请升级企业会员套餐',
}
